/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import React, { useEffect, useState } from 'react'
import { Grid, Typography, Button, Alert } from '@mui/material'
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { Formik, Form, Field } from 'formik'
import * as Yup from 'yup'
import { TextField } from 'formik-mui'
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { makeStyles } from 'tss-react/mui';
import { IMAGES } from '../../../config/assets';
import { authenticate, getUserInfo } from '../../../store/reducers/user/userAction';
import { useDispatch } from 'react-redux';



const LoginPage = () => {
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const [error, setError] = useState("")
  const dispatch = useDispatch();
  const handleSubmit = async (user, { setSubmitting }) => {
    const { username, password } = user
    if (username && password) {
      setLoading(true);


      try {

        const data = await dispatch(authenticate({ username, password })).unwrap()
        window.localStorage.setItem('getchkdjwt', data);

        setError("")
        await dispatch(getUserInfo()).unwrap();
        navigate('/dashboard')
      } catch (err) {
        setSubmitting(false);
        setLoading(false);
        setError("Invalid username or password.")
      }
    }
  }
  useEffect(() => { console.log("process.env.REACT_APP_REGISTER_MODE", process.env.REACT_APP_REGISTER_MODE) }, [])
  const { classes } = useStyles();
  return (
    <>
      <Box m={6}>

        <Grid container  >
          <Grid item xs={12} sm={1} md={1} />

          <Grid item xs={12} sm={10} md={10}>

            <Grid container className={classes.containerBox} >
              <Grid item xs={12} sm={12} md={3} />
              <Grid item xs={12} sm={12} md={6} >
                <Box m={2} className={classes.BoxContainerLogin} >
                  <Link
                    to={"/"}
                  >
                    <img src={IMAGES.LOGO_DARK} alt="" height="160px" className='AlignCenter' />
                  </Link>
                  <Typography color="primary" variant="h1" align="center">
                    Login To GetChkd User Web

                  </Typography>
                  <Grid container >

                    <Grid item xs={12} sm={12} md={12}>
                      {error && <Alert variant="filled" color='error'>{error}</Alert>}
                      <Formik
                        initialValues={{
                          username: '',
                          password: '',
                        }}

                        validationSchema={Yup.object().shape({
                          username: Yup.string().min(6).max(24).required(),
                          password: Yup.string().min(8).max(30).required()

                        })}
                        onSubmit={(
                          { username, password }, { setSubmitting }
                        ) => { handleSubmit({ username, password }, { setSubmitting }) }}
                      >
                        {() => (
                          <Form>

                            <Field
                              name="username"
                              label="Username"
                              type="text"
                              component={TextField}
                              margin="normal"
                              variant="outlined"
                              fullWidth
                            />


                            <Field
                              name="password"
                              label="Password"
                              type="password"
                              component={TextField}
                              margin="normal"
                              variant="outlined"
                              fullWidth
                            />

                            <Grid container spacing={6} style={{ marginTop: '20px' }}>
                              <Grid item xs={12} sm={12} md={12}>
                                <Button
                                  variant="contained"
                                  color="primary"
                                  size='large'
                                  type="submit"
                                  className={classes.button}
                                >
                                  {loading && <CircularProgress className={classes.progress} color="success" size={24} />}
                                  <Typography variant='h3' color="white"> Login</Typography>

                                </Button>
                                <span>{'  '}</span>
                                {process.env.REACT_APP_REGISTER_MODE === "true" && (
                                  <Button className={classes.button} onClick={() => { navigate("/register") }} >
                                    <Typography variant='h4'>Sign up</Typography>
                                  </Button>
                                )}

                              </Grid>
                            </Grid>

                          </Form>

                        )}

                      </Formik>


                    </Grid>

                  </Grid>

                </Box>

              </Grid>
            </Grid>
          </Grid>

        </Grid>
        <Grid item xs={12} sm={1} md={1} />

      </Box>
    </>
  )

}
const useStyles = makeStyles({ "name": { LoginPage } })(theme => ({
  heroContent: {
    height: 'calc( 100vh - 150px)',
  },

  button: {
    margin: theme.spacing(1),
    color: "white"
  },

  floatingLabelFocusStyle: {
    color: theme.palette.primary.main
  },
  ImgLoginDescp: {
    width: '300px',
    margin: 'auto',
    marginLeft: "auto",
    marginRight: 'auto'
  },
  containerBox: {
    display: 'flex',
    alignItems: 'center',
    borderRadius: '10px',
    backgroundSize: '100%',
    backgroundRepeat: 'no-repeat'
  },
  BoxContainerLogin: {
    padding: '1em',
    borderRadius: '10px',
    boxShadow: 'rgb(38 127 161) 1px 5px 24px 0px',

  }
}))

export default LoginPage;
